export enum TrainingSessionEventType {
  // Message Events
  ADMIN_MESSAGE = "admin_message",
  AI_MESSAGE = "ai_message",
  MESSAGE_REGENERATED = "message_regenerated",
  MESSAGE_GOOD_RESPONSE = "message_good_response",
  MESSAGE_BAD_RESPONSE = "message_bad_response",
  MESSAGE_GOOD_RESPONSE_UNDO = "message_good_response_undo",

  // Training Interaction Events
  TEST_INTERACTION_IN_TRAINING = "test_interaction_in_training",
  TEST_INTERACTION = "test_interaction",

  // Configuration Events
  EDIT_BRIEF = "edit_brief",
  EDIT_CONFIGURATION = "edit_configuration",
  MANUAL_ENABLE_TOPIC = "manual_enable_topic",
  MANUAL_DISABLE_TOPIC = "manual_disable_topic",

  // Instruction and Prerequisite Events
  CREATE_INSTRUCTION = "create_instruction",
  DELETE_INSTRUCTION = "delete_instruction",
  CREATE_PREREQUISITE = "create_prerequisite",
  DELETE_PREREQUISITE = "delete_prerequisite",

  // Improvement Events
  IMPROVE_SUGGESTED = "improve_suggested",
  IMPROVE_SUBMITTED = "improve_submitted",

  // File and Release Events
  UPLOAD_FILE = "upload_file",
  PUBLISH_RELEASE = "publish_release",
}

export interface TrainingSessionEvent {
  id: string;
  createdAt: string;
  eventCreatedAt: string;
  tenantId: string;
  type: TrainingSessionEventType;
  value: Record<string, any>;
  previousValue: Record<string, any> | null;
  quackUserId: string;
  simulatorId: number;
  releaseId: number;
  topicId?: number;
  releaseConversationId?: number;
  releaseCommentId?: number;
  topicReleasePolicyId?: string;
  instructionId?: string;
  prerequisiteId?: string;
  ticketInTrainingId?: number;
  conversationInTrainingId?: number;
  ticketId?: string;
  conversationId?: string;
}

export interface CreateTrainingSessionEventRequest {
  type: TrainingSessionEventType;
  value: Record<string, any>;
  previousValue?: Record<string, any>;
  simulatorId: number;
  releaseId: number;
  topicId?: number;
  releaseConversationId?: number;
  releaseCommentId?: number;
  topicReleasePolicyId?: string;
  instructionId?: string;
  prerequisiteId?: string;
  ticketInTrainingId?: number;
  conversationInTrainingId?: number;
  ticketId?: string;
  conversationId?: string;
}

export interface GetTrainingSessionEventsRequest {
  simulatorId?: number;
  releaseIds?: number[];
  topicIds?: number[];
  eventTypes?: TrainingSessionEventType[];
  startDate?: string;
  endDate?: string;
  userId?: string;
  page?: number;
  limit?: number;
  includeSessionsCount?: boolean;
  includeBadFeedbackCount?: boolean;
  includeGoodSessionCount?: boolean;
}

export interface GetTrainingSessionEventsResponse {
  events: TrainingSessionEvent[];
  totalCount: number;
  isThereNextPage: boolean;
  sessionsCount: number;
  goodSessionCount: number;
  badFeedbackCount: number;
}
